<!--{{ALLAPPS | json}}
<hr>
{{APPS | json}}
{{edit}} -->
<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Clonar perfil</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="profileForm">
      <div class="row">
        <div class="col">
          <div>
            <mdb-form-control>
              <mdb-select 
                [multiple]="false"
                formControlName="selectedFromUser"
                filter="true"
                filterPlaceholder="Buscar"
                (valueChange)="onUserFromSelected($event)"
              >
                <mdb-option *ngFor="let option of allUsers" [value]="option.value">{{option.label}}</mdb-option>
              </mdb-select>
              <label mdbLabel class="form-label">Selecione Usuario Origen</label>
            </mdb-form-control>
          </div>
  
        </div>
        <div class="col">
          <div>
            <mdb-form-control>
              <mdb-select
                [multiple]="false"
                formControlName="selectedToUser"
                filter="true"
                filterPlaceholder="Buscar"
                (valueChange)="onUserToSelected($event)"
              >
                <mdb-option *ngFor="let option of allUsers" [value]="option.value">{{option.label}}</mdb-option>
              </mdb-select>
              <label mdbLabel class="form-label">Selecione Usuario Destino</label>
            </mdb-form-control>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="shadow-0 btn btn-md btn-outline-primary"
      (click)="modalRef.close()"
    >
      Cancelar
    </button>

    <button 
      type="button"
      class="shadow-0 btn btn-md btn-primary"
      (click)="CloneProfile()"
      [textContent]="'Guardar'"
      [disabled]="profileForm.invalid"
      >
    </button>
  </div>

  <mdb-loading [show]="loading" [fullscreen]="true">
    <div class="loading-spinner">
      <div class="spinner-border loading-icon" role="status"></div>
      <span class="loading-text">Cargando datos...</span>
    </div>
  </mdb-loading>
